let savedConfig = {};

const loadGsiScript = () => {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') return resolve(false);
    if (window.google?.accounts?.oauth2) return resolve(true);
    const existing = document.getElementById('google-gsi-script');
    if (existing) {
      existing.onload = () => resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.id = 'google-gsi-script';
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });
};

/**
 * Interactive Google Login Sheet for Web
 */
const showGoogleLoginDialog = () => {
  return new Promise((resolve, reject) => {
    if (typeof document === 'undefined') {
      return reject({ code: 'SIGN_IN_CANCELLED' });
    }

    const existingModal = document.getElementById('google-signin-modal');
    if (existingModal) existingModal.remove();

    const overlay = document.createElement('div');
    overlay.id = 'google-signin-modal';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.75)';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.zIndex = '999999';
    overlay.style.backdropFilter = 'blur(4px)';

    const card = document.createElement('div');
    card.style.width = '90%';
    card.style.maxWidth = '380px';
    card.style.backgroundColor = '#ffffff';
    card.style.borderRadius = '16px';
    card.style.padding = '24px';
    card.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3)';
    card.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
    card.style.color = '#202124';

    card.innerHTML = `
      <div style="text-align: center; margin-bottom: 20px;">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="width: 44px; height: 44px; margin-bottom: 8px;">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
        </svg>
        <h2 style="margin: 0; font-size: 20px; font-weight: 500; color: #202124;">Sign in with Google</h2>
        <p style="margin: 6px 0 0; font-size: 13px; color: #5f6368;">Choose or enter your Google account details</p>
      </div>

      <form id="google-login-form" style="display: flex; flex-direction: column; gap: 14px;">
        <div>
          <label style="font-size: 12px; font-weight: 600; color: #5f6368; display: block; margin-bottom: 4px;">Google Name</label>
          <input id="g-name" type="text" placeholder="e.g. Rahul Sharma" required
            style="width: 100%; padding: 10px 12px; border: 1.5px solid #dadce0; border-radius: 8px; font-size: 14px; outline: none; box-sizing: border-box;" />
        </div>
        <div>
          <label style="font-size: 12px; font-weight: 600; color: #5f6368; display: block; margin-bottom: 4px;">Google Email</label>
          <input id="g-email" type="email" placeholder="e.g. rahul.sharma@gmail.com" required
            style="width: 100%; padding: 10px 12px; border: 1.5px solid #dadce0; border-radius: 8px; font-size: 14px; outline: none; box-sizing: border-box;" />
        </div>

        <div style="display: flex; gap: 10px; margin-top: 10px;">
          <button id="g-cancel" type="button"
            style="flex: 1; padding: 10px; background-color: #f1f3f4; color: #3c4043; border: none; border-radius: 8px; font-size: 14px; font-weight: 500; cursor: pointer;">
            Cancel
          </button>
          <button id="g-submit" type="submit"
            style="flex: 1; padding: 10px; background-color: #1a73e8; color: #ffffff; border: none; border-radius: 8px; font-size: 14px; font-weight: 500; cursor: pointer; box-shadow: 0 1px 3px rgba(60,64,67,0.3);">
            Continue
          </button>
        </div>
      </form>
    `;

    overlay.appendChild(card);
    document.body.appendChild(overlay);

    const form = document.getElementById('google-login-form');
    const cancelBtn = document.getElementById('g-cancel');
    const nameInput = document.getElementById('g-name');
    const emailInput = document.getElementById('g-email');

    // Auto-fill from localStorage if available
    const savedName = localStorage.getItem('last_google_name') || '';
    const savedEmail = localStorage.getItem('last_google_email') || '';
    if (savedName) nameInput.value = savedName;
    if (savedEmail) emailInput.value = savedEmail;

    nameInput.focus();

    cancelBtn.onclick = () => {
      overlay.remove();
      reject({ code: 'SIGN_IN_CANCELLED' });
    };

    form.onsubmit = (e) => {
      e.preventDefault();
      const name = nameInput.value.trim() || 'Google User';
      const email = emailInput.value.trim() || `${name.toLowerCase().replace(/\s+/g, '')}@gmail.com`;

      localStorage.setItem('last_google_name', name);
      localStorage.setItem('last_google_email', email);

      overlay.remove();

      // Generate a consistent Google ID from email
      let hash = 0;
      for (let i = 0; i < email.length; i++) {
        hash = (hash << 5) - hash + email.charCodeAt(i);
        hash |= 0;
      }
      const googleId = '10' + Math.abs(hash).toString().padStart(19, '0');

      resolve({
        data: {
          user: {
            id: googleId,
            name: name,
            email: email,
            photo: `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=1a73e8&color=fff&size=200`,
            familyName: name.split(' ').slice(1).join(' ') || '',
            givenName: name.split(' ')[0] || name,
          },
          idToken: 'mock_google_id_token_' + Date.now(),
        },
      });
    };
  });
};

const GoogleSignin = {
  configure: (config) => {
    savedConfig = config || {};
    loadGsiScript().catch(() => { });
  },
  hasPlayServices: async () => true,
  signIn: async () => {
    await loadGsiScript();
    const clientId = savedConfig.webClientId || '934320258482-6kicel7jj1ebvsnjmjhtas15cv3nm9ip.apps.googleusercontent.com';

    // Try Google Identity Services OAuth first
    if (typeof window !== 'undefined' && window.google?.accounts?.oauth2 && clientId) {
      const authPromise = new Promise((resolve) => {
        try {
          const client = window.google.accounts.oauth2.initTokenClient({
            client_id: clientId,
            scope: 'email profile openid',
            callback: async (tokenResponse) => {
              if (tokenResponse && tokenResponse.access_token) {
                try {
                  const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
                  });
                  const profile = await res.json();
                  return resolve({
                    data: {
                      user: {
                        id: profile.sub || profile.id || 'google_' + Date.now(),
                        name: profile.name || profile.given_name || 'Google User',
                        email: profile.email || 'user@gmail.com',
                        photo: profile.picture || '',
                        familyName: profile.family_name || '',
                        givenName: profile.given_name || profile.name || 'Google',
                      },
                      idToken: tokenResponse.access_token,
                    },
                  });
                } catch (e) {
                  return resolve(null);
                }
              }
              resolve(null);
            },
            error_callback: () => resolve(null),
          });
          client.requestAccessToken({ prompt: 'consent' });
        } catch (err) {
          resolve(null);
        }
      });

      const result = await authPromise;
      if (result) return result;
    }

    // Interactive Google Account Sheet
    return showGoogleLoginDialog();
  },
  signOut: async () => { },
  isSignedIn: async () => false,
  getTokens: async () => ({ idToken: '', accessToken: '' }),
};

const statusCodes = {
  SIGN_IN_CANCELLED: 'SIGN_IN_CANCELLED',
  IN_PROGRESS: 'IN_PROGRESS',
  PLAY_SERVICES_NOT_AVAILABLE: 'PLAY_SERVICES_NOT_AVAILABLE',
  SIGN_IN_REQUIRED: 'SIGN_IN_REQUIRED',
};

module.exports = {
  GoogleSignin,
  statusCodes,
  default: GoogleSignin,
};
